if (!customElements.get('kalaboost-experts-tabs')) {
  customElements.define(
    'kalaboost-experts-tabs',
    class KalaboostExpertsTabs extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[data-expert-avatar]'));
      }

      onClick(event) {
        const tab = event.target.closest('[data-expert-avatar]');
        if (tab && this.contains(tab)) {
          this.select(tab.dataset.blockId);
        }
      }

      onKeydown(event) {
        const tab = event.target.closest('[data-expert-avatar]');
        if (!tab || !this.contains(tab)) return;

        const tabs = this.tabs;
        const current = tabs.indexOf(tab);
        if (current < 0 || tabs.length < 2) return;

        let next = current;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (current + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (current - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(tabs[next].dataset.blockId);
        tabs[next].focus();
      }

      onBlockSelect(event) {
        const blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        if (!this.querySelector(`[data-expert-avatar][data-block-id="${blockId}"]`)) return;
        this.select(blockId);
      }

      select(blockId) {
        if (!blockId) return;

        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.blockId === blockId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.querySelectorAll('[data-expert-panel], [data-expert-quote]').forEach((panel) => {
          panel.toggleAttribute('hidden', panel.dataset.blockId !== blockId);
        });
      }
    }
  );
}
